import React from "react";
import TooltipV2 from "@ui/TooltipV2";
import t from "../../../../i18n";
import { css } from "@linaria/core";
import ButtonIconV2, { ButtonIconMarker } from "@ui/ButtonIconV2";
import { Filter3Line } from "@ui/IconV2/react";
import { useDisplayFilterPreferences } from "../useDisplayFilterPreferences";

interface Props {
  disabled?: boolean;
  projectId: string;
}

export default function DisplayFiltersToggleButton({ disabled = false, projectId }: Props) {
  const {
    isFiltersSelectionAvailable,
    selectedFilterIds,
    isFiltersSelectionVisible,
    setFiltersSelectionVisibility,
  } = useDisplayFilterPreferences(projectId);

  const handleClick = (visible: boolean) => {
    setFiltersSelectionVisibility(visible);
  };

  if (!isFiltersSelectionAvailable) {
    return null;
  }

  return (
    <TooltipV2 overlay={t("project.display_filter.toggle.title")}>
      <ButtonIconV2
        className={displayFiltersToggleButton}
        checked={!disabled && isFiltersSelectionVisible}
        onClick={() => handleClick(!isFiltersSelectionVisible)}
        disabled={disabled}
      >
        {!disabled && selectedFilterIds.length > 0 && <ButtonIconMarker />}
        <Filter3Line size="m" />
      </ButtonIconV2>
    </TooltipV2>
  );
}

const displayFiltersToggleButton = css`
  width: 22px;
  height: 22px;
`;
